(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');          
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              if(!sameCard) return;
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              if(!swiperContainer) return;
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              if(swiperPrevElement || swiperNextElement){
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.log(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sensory-quiz"] && !Shopify.designMode) return;
  try {
    
(function () {
  var QUIZ_STEPS = [
    {
      id: 'who',
      question: "Who's the chew for?",
      options: [
        { label: 'Me (an adult)', tags: [{ type: 'tag', value: 'Adult', weight: 3 }] },
        { label: 'My child', tags: [{ type: 'tag', value: 'Child', weight: 3 }] },
        { label: 'A baby or toddler', tags: [{ type: 'tag', value: 'Infant', weight: 3 }] }
      ]
    },
    {
      id: 'craving',
      question: 'What are you craving most?',
      options: [
        { label: 'Something to bite and chew on firmly', profileType: 'Chewer', tags: [{ type: 'tag', value: 'Oral Seeker', weight: 2 }] },
        { label: "I don't want anything in my mouth — just something to fidget with", profileType: 'Fidgeter', tags: [{ type: 'tag', value: 'Oral Avoider', weight: 2 }, { type: 'tag', value: 'Touch Seeker', weight: 2 }] },
        { label: 'Interesting textures to touch and play with', profileType: 'Toucher', tags: [{ type: 'tag', value: 'Touch Seeker', weight: 2 }] },
        { label: 'Gentle movement that helps me feel calm', profileType: 'Calm Seeker', tags: [{ type: 'tag', value: 'Vestibular Seeker', weight: 2 }] }
      ]
    },
    {
      id: 'discreet',
      question: 'How discreet should it be?',
      options: [
        { label: 'Very discreet — it should look like everyday jewellery', profileModifier: 'Discreet', tags: [{ type: 'tag', value: 'Discreet', weight: 1.5 }] },
        { label: "Doesn't matter — the more colourful, the better", profileModifier: 'Colourful', tags: [] }
      ]
    },
    {
      id: 'style',
      question: 'What style do you prefer?',
      options: [
        { label: 'A necklace or pendant', tags: [{ type: 'collection', value: 'pendants', weight: 2 }] },
        { label: 'A bracelet or bangle', tags: [{ type: 'collection', value: 'bangles', weight: 2 }] },
        { label: 'A fidget toy or accessory', tags: [{ type: 'collection', value: 'fidgets', weight: 2 }] },
        { label: "Not sure — just show me the best matches", tags: [] }
      ]
    }
  ];

  var COLLECTION_LABELS = { pendants: 'Pendants', bangles: 'Bangles', fidgets: 'Fidgets', accessories: 'Accessories' };
  var COLLECTION_URLS = { pendants: '/collections/pendants', bangles: '/collections/bangles', fidgets: '/collections/fidgets', accessories: '/collections/accessories' };
  var KNOWN_COLLECTIONS = ['pendants', 'bangles', 'fidgets', 'accessories'];

  var TYPE_DESCRIPTIONS = {
    'Chewer': "you want something satisfying to bite and chew on, so you can stay focused when things get overwhelming.",
    'Fidgeter': "you'd rather have something to fidget with in your hands than in your mouth, keeping restless energy in check.",
    'Toucher': "you're drawn to interesting textures you can touch and explore, which helps you feel grounded.",
    'Calm Seeker': "gentle, repetitive movement helps you feel calm, so something you can twist, rock or spin works best."
  };
  var MODIFIER_CLAUSES = {
    'Discreet': "You'd rather it blend in and look like everyday jewellery.",
    'Colourful': "You're not fussed about blending in — the bolder and more colourful, the better."
  };
  var AUDIENCE_CLAUSES = {
    'Adult': 'Since it’s for you,',
    'Child': 'Since it’s for your child,',
    'Infant': 'Since it’s for a baby or toddler,'
  };

  function slugify(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  document.querySelectorAll('[data-sensory-quiz]').forEach(function (root) {
    var productsEl = root.querySelector('[data-quiz-products]');
    var products = [];
    try { products = JSON.parse(productsEl.textContent); } catch (e) { products = []; }

    var introEl = root.querySelector('[data-quiz-intro]');
    var appEl = root.querySelector('[data-quiz-app]');
    var bodyEl = root.querySelector('[data-quiz-body]');
    var progressBar = root.querySelector('[data-quiz-progress-bar]');
    var startBtn = root.querySelector('[data-quiz-start]');
    var closeBtn = root.querySelector('[data-quiz-close]');

    var currentStep = 0;
    var answers = [];
    var chosenCollection = null;
    var quizProfile = null;
    var resultCollection = null;
    var resultProduct = null;

    function openQuiz() {
      introEl.hidden = true;
      appEl.hidden = false;
      currentStep = 0;
      answers = [];
      chosenCollection = null;
      quizProfile = null;
      resultCollection = null;
      resultProduct = null;
      renderStep();
      appEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function closeQuiz() {
      appEl.hidden = true;
      introEl.hidden = false;
    }

    function renderStep() {
      var step = QUIZ_STEPS[currentStep];
      progressBar.style.width = Math.round((currentStep / QUIZ_STEPS.length) * 100) + '%';

      var html = '';
      html += '<p class="sensory-quiz__step-count">Question ' + (currentStep + 1) + ' of ' + QUIZ_STEPS.length + '</p>';
      html += '<p class="sensory-quiz__question">' + step.question + '</p>';
      html += '<div class="sensory-quiz__options">';
      step.options.forEach(function (opt, idx) {
        html += '<button type="button" class="sensory-quiz__option" data-option-index="' + idx + '">' + opt.label + '</button>';
      });
      html += '</div>';
      html += '<div class="sensory-quiz__nav"><button type="button" class="sensory-quiz__back" data-quiz-back' + (currentStep === 0 ? ' hidden' : '') + '>&larr; Back</button></div>';

      bodyEl.innerHTML = html;

      bodyEl.querySelectorAll('[data-option-index]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-option-index'), 10);
          var opt = step.options[idx];
          answers[currentStep] = opt;
          if (step.id === 'style') {
            opt.tags.forEach(function (t) {
              if (t.type === 'collection') chosenCollection = t.value;
            });
          }
          if (currentStep < QUIZ_STEPS.length - 1) {
            currentStep++;
            renderStep();
          } else {
            quizProfile = generateProfile(answers);
            resultCollection = chosenCollection || pickBestCollection(answers);
            resultProduct = pickTopProduct(answers);
            renderEmailGate();
          }
        });
      });

      var backBtn = bodyEl.querySelector('[data-quiz-back]');
      if (backBtn) {
        backBtn.addEventListener('click', function () {
          if (currentStep > 0) {
            currentStep--;
            renderStep();
          }
        });
      }
    }

    function scoreProduct(product, allAnswers) {
      var score = 0;
      allAnswers.forEach(function (opt) {
        if (!opt) return;
        opt.tags.forEach(function (t) {
          if (t.type === 'tag' && product.tags.indexOf(t.value) !== -1) {
            score += t.weight;
          } else if (t.type === 'collection' && product.collections.indexOf(t.value) !== -1) {
            score += t.weight;
          }
        });
      });
      return score;
    }

    function pickBestCollection(allAnswers) {
      var collectionScores = {};
      products.forEach(function (p) {
        var s = scoreProduct(p, allAnswers);
        if (s <= 0) return;
        p.collections.forEach(function (c) {
          if (KNOWN_COLLECTIONS.indexOf(c) !== -1) {
            collectionScores[c] = (collectionScores[c] || 0) + s;
          }
        });
      });
      var best = null;
      var bestScore = 0;
      Object.keys(collectionScores).forEach(function (c) {
        if (collectionScores[c] > bestScore) {
          bestScore = collectionScores[c];
          best = c;
        }
      });
      return best;
    }

    function pickTopProduct(allAnswers) {
      var best = null;
      var bestScore = 0;
      products.forEach(function (p) {
        var s = scoreProduct(p, allAnswers);
        if (s > bestScore) {
          bestScore = s;
          best = p;
        }
      });
      return best;
    }

    function generateProfile(allAnswers) {
      var audience = (allAnswers[0] && allAnswers[0].tags[0]) ? allAnswers[0].tags[0].value : 'Adult';
      var type = (allAnswers[1] && allAnswers[1].profileType) ? allAnswers[1].profileType : 'Chewer';
      var modifier = (allAnswers[2] && allAnswers[2].profileModifier) ? allAnswers[2].profileModifier : 'Discreet';

      var title = 'The ' + modifier + ' ' + type;
      var description = (AUDIENCE_CLAUSES[audience] || 'Based on your answers,') + ' ' +
        TYPE_DESCRIPTIONS[type] + ' ' + MODIFIER_CLAUSES[modifier];

      return { title: title, description: description, type: type, modifier: modifier, audience: audience };
    }

    function submitEmailCapture(email) {
      try {
        var collectionKey = resultCollection || 'all';
        var tags = [
          'newsletter',
          'quiz-lead',
          'quiz-type-' + slugify(quizProfile.type),
          'quiz-modifier-' + slugify(quizProfile.modifier),
          'quiz-audience-' + slugify(quizProfile.audience),
          'quiz-collection-' + slugify(collectionKey)
        ];
        var body = new URLSearchParams();
        body.append('form_type', 'customer');
        body.append('utf8', '✓');
        body.append('contact[email]', email);
        body.append('contact[tags]', tags.join(', '));
        fetch('/contact#ContactFooter', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        }).catch(function () {});
      } catch (e) {}
    }

    function renderEmailGate() {
      progressBar.style.width = '100%';

      var html = '';
      html += '<p class="sensory-quiz__step-count">Almost there!</p>';
      html += '<p class="sensory-quiz__question">Your sensory profile is ready</p>';
      html += '<p class="sensory-quiz__gate-sub">Pop in your email and we’ll reveal your personalised profile, plus save it so we can point you to the right products in future.</p>';
      html += '<div class="sensory-quiz__email-gate">';
      html += '<input type="email" class="sensory-quiz__email-input" data-quiz-email placeholder="you@example.com" required>';
      html += '<label class="sensory-quiz__consent"><input type="checkbox" data-quiz-consent> Yes, send me my profile and occasional offers from Chewigem by email</label>';
      html += '<button type="button" class="sensory-quiz__cta sensory-quiz__reveal-btn" data-quiz-reveal disabled>Reveal My Profile</button>';
      html += '</div>';
      html += '<button type="button" class="sensory-quiz__skip-link" data-quiz-skip>Skip and see my matches</button>';
      html += '<div class="sensory-quiz__nav"><button type="button" class="sensory-quiz__back" data-quiz-back>&larr; Back</button></div>';

      bodyEl.innerHTML = html;

      var emailInput = bodyEl.querySelector('[data-quiz-email]');
      var consentInput = bodyEl.querySelector('[data-quiz-consent]');
      var revealBtn = bodyEl.querySelector('[data-quiz-reveal]');
      var skipBtn = bodyEl.querySelector('[data-quiz-skip]');
      var backBtn = bodyEl.querySelector('[data-quiz-back]');

      function updateRevealState() {
        var validEmail = !!emailInput.value && emailInput.checkValidity();
        revealBtn.disabled = !(validEmail && consentInput.checked);
      }
      emailInput.addEventListener('input', updateRevealState);
      consentInput.addEventListener('change', updateRevealState);

      revealBtn.addEventListener('click', function () {
        if (revealBtn.disabled) return;
        submitEmailCapture(emailInput.value.trim());
        renderResults();
      });

      skipBtn.addEventListener('click', function () {
        renderResults();
      });

      backBtn.addEventListener('click', function () {
        currentStep = QUIZ_STEPS.length - 1;
        renderStep();
      });
    }

    function renderResults() {
      progressBar.style.width = '100%';

      var collectionKey = resultCollection;
      var collectionLabel = (collectionKey && COLLECTION_LABELS[collectionKey]) || 'Products';
      var collectionUrl = (collectionKey && COLLECTION_URLS[collectionKey]) || '/collections/all';
      var hasImage = resultProduct && resultProduct.image;

      var html = '';
      html += '<div class="sensory-quiz__results' + (hasImage ? '' : ' sensory-quiz__results--no-media') + '">';
      if (hasImage) {
        html += '<div class="sensory-quiz__results-media">';
        html += '<img class="sensory-quiz__results-image" src="' + resultProduct.image + '" alt="' + resultProduct.title.replace(/"/g, '&quot;') + '" loading="lazy">';
        html += '</div>';
      }
      html += '<div class="sensory-quiz__results-content">';
      html += '<p class="sensory-quiz__profile-eyebrow">Your sensory profile</p>';
      html += '<p class="sensory-quiz__profile-title">' + quizProfile.title + '</p>';
      html += '<p class="sensory-quiz__profile-desc">' + quizProfile.description + '</p>';
      html += '<div class="sensory-quiz__results-actions">';
      html += '<a class="sensory-quiz__view-all" href="' + collectionUrl + '">Shop Your ' + collectionLabel + ' Matches</a>';
      html += '<button type="button" class="sensory-quiz__retake" data-quiz-retake>Retake the quiz</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';

      bodyEl.innerHTML = html;

      var retakeBtn = bodyEl.querySelector('[data-quiz-retake]');
      if (retakeBtn) {
        retakeBtn.addEventListener('click', openQuiz);
      }
    }

    if (startBtn) startBtn.addEventListener('click', openQuiz);
    if (closeBtn) closeBtn.addEventListener('click', closeQuiz);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
